const loggedIn = (loggedIn = null, action) => {
  switch (action.type) {
    case 'SET_LOGGED_IN':
      return action.payload
    default:
      return loggedIn
  }
}
export default loggedIn
